module.exports = __webpack_public_path__ + "img/sleep.28a5c364.svg";